import React from 'react'
import { Button} from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import {getUpSellIconType} from '../shared/enums/upsell-icon-type'
import {getTaskTypeIconParser} from'../shared/enums/task-type-icon-parser'

const OrderConfirmationModal = React.createClass({

  render: function () {
      let check = '/common/latest/images/consumer/upsells/check.png'
      let invertCheck = '/common/latest/images/consumer/upsells/invert-check.png'

     let taskType = 'AERATELAWN'
    if(this.props.modalProps.card) {
       taskType = getUpSellIconType(this.props.modalProps.card.upSellType)
       taskType = getTaskTypeIconParser(taskType.prettify).apiName
    }
    else if(this.props.modalProps.modalCard) {
      taskType = this.props.modalProps.modalCard.taskType
    }

    let price
    if(this.props.modalProps.modalCard) {
        price = this.props.modalProps.modalCard.cost
    }
    else {
        price = this.props.taskData.price
    }

    let color, newTitle;

    color = getTaskTypeIconParser(taskType).iconsrc + '-background'
    newTitle = getTaskTypeIconParser(taskType).prettify

    let displayAddress = this.props.modalProps.streetAddress

    if(this.props.confirmationAddress) {
        displayAddress = this.props.confirmationAddress
    }
    return (
      <div >
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='upsell-modal-size'>
          <div className='white-background'>
            <Modal.Header closeButton>
                <div className='text-center' style={{marginTop: 25}}>
                    <h2>Order Confirmation</h2>
                    <span style={{fontSize: 22}}><b>Thank you for your order!</b></span>
                    <br/>
                    <span style={{fontSize: 22}}><b>Your order number is #{this.props.orderNumber}</b></span>
                    <br/>
                    <p className='pull-down-xs-3' style={{fontSize: 20}}>We’ve sent an order confirmation to {this.props.login.customer.loginName}</p>
                <p className='text-center pull-down-xs-3' style={{fontSize: 26}}>Your {newTitle} summary:</p>
                <div className={color} style={{paddingTop: 10 ,margin: 'auto', width: 350, height: 175, color: 'white', textAlign: 'center', marginBottom: 20, borderRadius: 3, fontSize: 18}}>
                    <span style={{fontWeight: 100}} ><b>{newTitle}</b> for <br/> {displayAddress}</span>
                    <div style={{width: 301, height: 3, margin: 'auto', opacity: 0.33, borderBottom: 'solid 1px #646464', paddingTop: 10}}></div>
                    <span style={{fontWeight: 100}}><b style={{fontSize: 46}}>${price}</b>/service</span>
                    <p>One-Time {newTitle}</p>
                </div>
                <Button type='button' bsClass='btn btn-success btn-sm center-block' onClick={this.props.hide}>
                Go to my dashboard
                </Button>
                </div>
            </Modal.Header>
            <Modal.Footer className='baseline-background' style={{color: 'white', textAlign: 'center'}}>
                 <h3>What happens next?</h3>
                 <div className='row pull-down-xs-3' style={{textAlign: 'left'}}>
                     <div className='col-xs-2'>
                         <img alt='' style={{width: 34, height: 34, position: 'absolute', right: 0, top: -10}}src={check}/>
                         </div>
                     <div className='col-xs-10'>We’ve sent an order confirmation to {this.props.login.customer.loginName}</div>
                     <br/>
                     <br/>
                     <br/>
                     <div className='col-xs-2'>
                         <img alt='' style={{width: 34, height: 34, position: 'absolute',right: 0, top: '-10px'}}src={invertCheck}/>
                         </div>
                     <div className='col-xs-10'>Your Task is Finished! When your contractor completes the {newTitle} task, you’ll receive another email with photos and a request to approve payment.</div>
                 </div>

            </Modal.Footer>
          </div>
        </Modal>
      </div>
    )
  }
})

export default OrderConfirmationModal


// WEBPACK FOOTER //
// ./src/components/modals/order-confirmation-modal.jsx